var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("\n    Här får du med liggande genomskjutningsskydd till varje nivå. Genomskjutningsskydden hindrar genomskjutning av pallen och är som regel ett krav för att pallstället ska vara godkänt.\n  ")])])
}]

export { render, staticRenderFns }